import {
  Component, EventEmitter, Input, Output, OnChanges,
  SimpleChanges, ChangeDetectionStrategy
} from '@angular/core';
import { Tutorial, parseSharePointVideoUrl } from '../../models';

@Component({
  selector: 'app-tutorial-form-dialog',
  templateUrl: './tutorial-form-dialog.component.html',
  styleUrls: ['./tutorial-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TutorialFormDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() tutorial: Tutorial | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<Record<string, any>>();

  title = '';
  description = '';
  videoUrl = '';

  /** Empty is allowed; otherwise must be an https SharePoint URL */
  get isVideoUrlValid(): boolean {
    return !this.videoUrl.trim() || parseSharePointVideoUrl(this.videoUrl) !== null;
  }

  get isEditMode(): boolean {
    return this.tutorial !== null;
  }

  get dialogTitle(): string {
    return this.isEditMode ? 'Edit Tutorial' : 'Create Tutorial';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      if (this.tutorial) {
        this.title = this.tutorial.Title;
        this.description = this.tutorial.Description;
        this.videoUrl = this.tutorial.VideoLink ?? '';
      } else {
        this.title = '';
        this.description = '';
        this.videoUrl = '';
      }
    }
  }

  onSave(): void {
    if (!this.title.trim() || !this.isVideoUrlValid) { return; }
    this.save.emit({
      Title: this.title.trim(),
      Description: this.description.trim(),
      VideoLink: this.videoUrl.trim() || null,
      IsActive: true
    });
    this.onClose();
  }

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
